var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import DixaIcon from '@dixa/dixa-modern-icons';
import classnames from 'classnames';
import { PureComponent } from 'react';
import styles from './teamChannelIcon.module.scss';
export class TeamChannelIcon extends PureComponent {
    render() {
        const _a = this.props, { className, active, icon, numberOfConversations } = _a, otherProps = __rest(_a, ["className", "active", "icon", "numberOfConversations"]);
        const withText = numberOfConversations !== undefined;
        const zeroConversations = withText && numberOfConversations === 0;
        const activeWithZeroConversations = !!active && zeroConversations;
        const notActiveWithZeroConversations = !active && zeroConversations;
        const activeWithConversations = !!active && !zeroConversations;
        const notActiveWithConversations = !active && !zeroConversations;
        const withoutTextActive = !withText && !!active;
        const withoutTextNotActive = !withText && !active;
        const rootClass = classnames({
            [styles.iconBackground]: true,
            [styles.iconBackgroundWithoutText]: !withText,
            [styles.iconBackgroundZeroActive]: withText && activeWithZeroConversations,
            [styles.iconBackgroundZeroNotActive]: withoutTextNotActive || notActiveWithZeroConversations,
            [styles.iconBackgroundPositiveActive]: withoutTextActive || activeWithConversations,
            [styles.iconBackgroundPositiveNotActive]: withText && notActiveWithConversations,
        }, className);
        const iconClass = classnames(styles.icon, 'icon-vertical-fix-block');
        const cappedConversations = numberOfConversations && numberOfConversations > 9
            ? '9+'
            : numberOfConversations;
        return (_jsxs("div", Object.assign({}, otherProps, { className: rootClass }, { children: [_jsx(DixaIcon, { icon: icon, className: iconClass }), withText && _jsx("span", Object.assign({ className: styles.text }, { children: cappedConversations }))] })));
    }
}
